import React from 'react';
import { AsyncComponent } from '@twigeducation/async-component';
import { withSignoutRedirect } from '@twigeducation/oidc-client-react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import districtOwnerMenu from './districtOwnerMenu.json';
import districtOwnerMenuEs from './districtOwnerMenu-es.json';
import filterMenuAccordingToIntegration from '../../helpers/filterMenu';
import districtDetailsQuery from '../../UserDetails.query';
import { FLAG_RTK_ROSTERING_DEPRECATIONS } from '../../constants';

const NavbarComponent = state => {
    const { userInfo, jsonMenu, featureFlags } = state;
    const { data, loading } = useQuery(districtDetailsQuery, {
        skip: !(userInfo && userInfo.id),
    });
    const props = { ...state };
    const district = !loading && data?.currentUser?.district ? data.currentUser.district : '';
    props.menuItemsAsJson = filterMenuAccordingToIntegration(jsonMenu, district, userInfo, featureFlags);
    return <AsyncComponent appName="ms-navbar-mfe" componentName="Navbar" {...props} />;
};

const NavbarWithLogoutHandler = ({ onLogout, featureFlags, ...props }) => {
    const rosteringDeprecated = !!(featureFlags && featureFlags[FLAG_RTK_ROSTERING_DEPRECATIONS]);
    const handleLogout = shouldLogout => {
        if (shouldLogout) {
            if (rosteringDeprecated) {
                window.location.href = window.config.SIGNIN_REDIRECT_URL;
            } else {
                onLogout();
            }
        } else {
            window.location.href = window.config.PRODUCT_SELECTION_URL;
        }
    };

    return <NavbarComponent {...props} featureFlags={featureFlags} onLogout={handleLogout} />;
};

NavbarWithLogoutHandler.propTypes = {
    onLogout: PropTypes.func.isRequired,
    featureFlags: PropTypes.objectOf(PropTypes.bool),
};

NavbarWithLogoutHandler.defaultProps = {
    featureFlags: {},
};

const mapStateToProps = state => {
    const language = state?.product?.ietfTag || 'en-US';
    const jsonMenu = language === 'es-US' ? districtOwnerMenuEs : districtOwnerMenu;
    return { userInfo: state.userInfo, jsonMenu, hostApp: 'admin', featureFlags: state.featureFlags };
};
export default withSignoutRedirect(() => {})(connect(mapStateToProps)(NavbarWithLogoutHandler));
